import { put } from "redux-saga/effects";
import { SET_FAILED_API_ERROR } from "redux/constants";

export function* setError(failedType, error, customError) {
  const toastifyError = customError || error;
  yield put({ type: failedType, error: error });
  yield put({ type: SET_FAILED_API_ERROR, payload: { failed: true, error: toastifyError } });
}
